(function (angular) {
  "use strict";

  customAttrsConfig.$inject = [];

  function customAttrsConfig() {
    function link($scope) {
      $scope.listTemplate = {
        value: {
          label: "Value",
          type: "string",
          placeholder: "",
        },
      };

      // methods
      $scope.addSelectItem = addSelectItem;
      $scope.addCheckboxesItem = addCheckboxesItem;
      $scope.addTextItem = addTextItem;
      $scope.removeItem = removeItem;

      /**
       * Adds a new blank select item
       * @return {void}
       */
      function addSelectItem() {
        $scope.ngModel.push({
          key: "",
          custom: true,
          type: "select",
          label: "",
          options: {
            options: [],
          },
          private: false,
          required: false,
          visible: false,
          tab: "",
        });
      }

      /**
       * Adds a new checkboxes item
       * @return {void}
       */
      function addCheckboxesItem() {
        $scope.ngModel.push({
          key: "",
          custom: true,
          type: "checkboxes",
          label: "",
          options: {
            options: [],
          },
          private: false,
          required: false,
          visible: false,
          tab: "",
        });
      }

      /**
       * Adds a new text field item
       * @return {void}
       */
      function addTextItem() {
        $scope.ngModel.push({
          key: "",
          custom: true,
          type: "text",
          label: "",
          private: false,
          required: false,
          visible: false,
          tab: "",
        });
      }

      /**
       * Removes an item from the model
       * @param  {object} customAttr - item from ngModel
       * @return {void}
       */
      function removeItem(customAttr) {
        var index = $scope.ngModel.indexOf(customAttr);
        $scope.ngModel.splice(index, 1);
      }
    }

    return {
      link: link,
      restrict: "E",
      scope: {
        ngModel: "=",
      },
      templateUrl: "directives/custom-attrs-config.html",
    };
  }

  angular.module("app").directive("customAttrsConfig", customAttrsConfig);
})(angular);
